export enum DateDueKey {
  HideOverdue = 'hide_overdue',
  DueToday = 'due_today',
  ApproachingDueDate = 'approaching_due_date',
  Custom = 'custom',
}

export const DateDueOptionsMap: Record<DateDueKey, { name: string; value: string }> = {
  [DateDueKey.HideOverdue]: {
    name: 'Hide Overdue',
    value: DateDueKey.HideOverdue,
  },
  [DateDueKey.DueToday]: {
    name: 'Due Today',
    value: DateDueKey.DueToday,
  },
  [DateDueKey.ApproachingDueDate]: {
    name: 'Approaching Due Date',
    value: DateDueKey.ApproachingDueDate,
  },
  [DateDueKey.Custom]: {
    name: 'Custom Date Range',
    value: DateDueKey.Custom,
  },
};

export const getDateDueOptions = (keys: DateDueKey[]): { name: string; value: string }[] => {
  return keys.map((key) => DateDueOptionsMap[key]);
};
